// data.js
const products = [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 1 Description',
    },
    {
      id: 2,
      image: 'https://plus.unsplash.com/premium_photo-1664537975186-f7ad7218a5c2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1526889836072-dbb0f1dbce66?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1535365229039-e36084b548f0?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1555412590-954a889ccb90?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1526888935184-a82d2a4b7e67?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    }
    // Add more products as needed
  ];
  
  export default products;
  